<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkposition_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/position/parkposition';
import { regionSelections } from '@/api/v4ward/park/region/parkregion';
import { driverSelections } from '@/api/v4ward/park/driver/parkdriver';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      operateType: '',
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        labelWidth: 120,
        align: 'center',
        indexLabel: '序号',
        dialogWidth: '40%',
        column: [
          {
            label: '停车场',
            prop: 'parkingLotId',
            type: 'select',
            dicUrl: '/api/parking/lot/selections',
            editDisabled: true,
            search: true,
            props: {
              label: 'label',
              value: 'value',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '所属区域',
            prop: 'regionId',
            type: 'tree',
            editDisabled: false,
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择车位区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车位名称',
            prop: 'parkingSpaceName',
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入车位名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车位编号',
            prop: 'parkingSpaceCode',
            maxlength: 16,
            rules: [
              {
                required: true,
                message: '请输入车位编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车位状态',
            prop: 'parkingSpaceStatus',
            type: 'select',
            value: '1',
            dicData: [
              { label: '闲置', value: '1' },
              { label: '出售', value: '2' },
              { label: '出租', value: '3' },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择车位状态',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车位归属人',
            prop: 'driverId',
            hide: true,
            editDisabled: true,
            addDisabled: true,
            viewDisplay: false,
            type: 'select',
            dicData: [],
            props: {
              label: 'label',
              value: 'value',
              disabled: 'disabled',
            },
            rules: [
              {
                validator: (rule, value, callback) => {
                  let status = this.form.parkingSpaceStatus;
                  if (status === '2' || status === '3') {
                    if (typeof this.form.driverId === 'undefined' || this.form.driverId === '') {
                      callback(new Error('出租或出售时必填！'));
                    } else {
                      callback();
                    }
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '归属人',
            prop: 'driverName',
            editDisplay: false,
            addDisplay: false,
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            span: 24,
            maxlength: 128,
            overHidden: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkposition_add, true),
        viewBtn: this.vaildData(this.permission.parkposition_view, true),
        delBtn: this.vaildData(this.permission.parkposition_delete, true),
        editBtn: this.vaildData(this.permission.parkposition_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'form.parkingLotId'() {
      this.loadRegionSelections(this.form.parkingLotId);
      this.loadDriverSelections();
    },
    'form.parkingSpaceStatus'() {
      this.loadDriverSelections();
    },
  },
  mounted() {
    this.loadRegionSelections();
  },
  methods: {
    loadDriverSelections() {
      const column = this.findObject(this.option.column, 'driverId');
      this.form.driverId = '';
      column.addDisabled = true;
      column.editDisabled = true;
      if (typeof this.form.parkingSpaceStatus !== 'undefined') {
        if (this.form.parkingSpaceStatus === '2' || this.form.parkingSpaceStatus === '3') {
          column.addDisabled = false;
          column.editDisabled = false;
          if (typeof this.form.parkingLotId !== 'undefined' && this.form.parkingLotId !== '') {
            driverSelections({ id: this.form.parkingLotId }).then((res) => {
              column.dicData = res.data;
            });
          }
        }
      }
    },
    loadRegionSelections(parkId) {
      regionSelections({ parkId: parkId }).then((res) => {
        if (this.operateType === 'add') {
          this.form.regionId = '';
        }
        const column = this.findObject(this.option.column, 'regionId');
        column.addDisabled = !(typeof parkId !== 'undefined' && parkId !== '');
        column.dicData = res.data;
      });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      this.operateType = type;
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
